import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings/public").then((r) => r.data) }).data;

export const useProducts = () =>
  useQuery({ queryKey: ["products"], queryFn: () => api.get("/products").then((r) => r.data) });
